// utils/PCMPlayerManager.js
import PCMPlayer from './PCMPlayer';

export class PCMPlayerManager {
  constructor(options = {}) {
    this.pcmPlayer = null;
    this.audioQueue = [];
    this.processingQueue = false;
    this.onPlaybackEnd = options.onPlaybackEnd || null;

    // console.log('PCMPlayerManager initialized');
  }

  initialize() {
    // console.log('Initializing PCM Player');
    if (this.pcmPlayer) {
      this.destroy();
    }
    this.pcmPlayer = new PCMPlayer({
      inputCodec: 'Int16',
      channels: 1,
      sampleRate: 24000,
      flushTime: 500,
      fftSize: 2048,
      // onstatechange: (audioCtx, event, state) => {
      //   console.log('PCMPlayer onstatechange:', state);
      // },
      onended: (sourceNode, event) => {
        // console.log('Delayed final onended triggered.');
        if (this.onPlaybackEnd) {
          this.onPlaybackEnd(sourceNode, event);
        }
      }
    });
  }

  feed(chunk) {
    if (!this.pcmPlayer) {
      this.initialize();
    }
    this.audioQueue.push(chunk);
    if (!this.processingQueue) {
      this.processQueue();
    }
  }

  processQueue() {
    if (this.audioQueue.length === 0) {
      this.processingQueue = false;
      // console.log('Audio queue empty, nothing to process further.');
      return;
    }
    this.processingQueue = true;

    const chunk = this.audioQueue.shift();
    try {
      this.pcmPlayer.feed(chunk);
    } catch (error) {
      console.error('Error feeding chunk to PCMPlayer:', error);
    }

    // Slight delay to avoid saturating feed
    setTimeout(() => this.processQueue(), 50);
  }

  flush() {
    // console.log('Flushing PCMPlayer');
    if (this.pcmPlayer) {
      this.pcmPlayer.flush();
    }
  }

  destroy() {
    if (this.pcmPlayer) {
      this.pcmPlayer.destroy();
      this.pcmPlayer = null;
    }
    this.audioQueue = [];
    this.processingQueue = false;
  }

  stop() {
    this.destroy();
    this.initialize();
  }
}
